import { action } from 'mobx';
import BaseStore from 'core/stores/BaseStore';
import { ApplicationService } from 'common/data';
class ApplicationStore extends BaseStore {
	constructor(rootStore) {
		super(new ApplicationService(rootStore.app.baasic.apiClient));
	}

	@action async countWarehouses(filter) {
		const response = await this.service.countWarehouses(filter);
		this.item = response.data;
	}

	@action async getOrganizationInfo() {
		const response = await this.service.getOrganizationInfo();
		this.item = response.data;
		return response.data;
	}

	@action async updateSellerWarehouseManagements(updateSellerWarehouseManagementsParams, sourceOfChange) {
		const response = await this.service.updateSellerWarehouseManagements(
			updateSellerWarehouseManagementsParams,
			sourceOfChange
		);
		return response.data;
	}

	@action async updateSellerWarehouses(updateSellerWarehousesParams, sourceOfChange) {
		const response = await this.service.updateSellerWarehouses(updateSellerWarehousesParams, sourceOfChange);
		return response.data;
	}

	@action async getApplication(id, options = {}) {
		const response = await this.service.get(id, options);
		this.item = response.data;
	}

	@action async createApplication(application, sourceOfChange) {
		await this.service.create(application, sourceOfChange);
	}

	@action async updateApplication(application, sourceOfChange) {
		await this.service.update(application, sourceOfChange);
	}

	@action async deleteApplication(resource) {
		await this.service.delete(resource);
	}

	@action async changeStatus(id, isReactivate) {
		await this.service.changeStatus(id, isReactivate);
	}

}
export default ApplicationStore;
